import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register" }
const _hoisted_2 = { class: "register-left" }
const _hoisted_3 = { class: "register-left-inner" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "register-left-back-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "21",
    height: "13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.987.15a.5.5 0 0 1-.008.707L1.726 6H20.5a.5.5 0 0 1 0 1H1.726l5.253 5.143a.5.5 0 0 1-.7.714l-6.129-6a.5.5 0 0 1 0-.714l6.13-6a.5.5 0 0 1 .707.007Z",
      fill: "#fff"
    })
  ])
], -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "register-right" }
const _hoisted_7 = { class: "register-right-nav" }
const _hoisted_8 = ["aria-selected", "tabindex"]
const _hoisted_9 = ["aria-selected", "disabled", "tabindex"]
const _hoisted_10 = ["aria-selected", "disabled", "tabindex"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderNotConnected = _resolveComponent("HeaderNotConnected")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_FormAccount = _resolveComponent("FormAccount")!
  const _component_FormGeneral = _resolveComponent("FormGeneral")!
  const _component_FormStaff = _resolveComponent("FormStaff")!
  const _component_ErrorPopin = _resolveComponent("ErrorPopin")!
  const _component_ThanksPanel = _resolveComponent("ThanksPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderNotConnected, {
      class: "register-header",
      register: true
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RouterLink, {
          to: "/",
          class: "register-left-back"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('register-form.back-home')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Logo, { light: true }),
        _createElementVNode("h1", {
          class: "register-left-title h1",
          innerHTML: _ctx.$t('staff-form.title')
        }, null, 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("nav", _hoisted_7, [
        _createElementVNode("div", {
          onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onNavKeyDown && _ctx.onNavKeyDown(...args))),
          class: "register-right-nav-inner",
          role: "tablist",
          "aria-label": "Form"
        }, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onNavClick(0))),
            role: "tab",
            "aria-selected": _ctx.currentTab === 0,
            "aria-controls": "account-tab",
            tabindex: _ctx.currentTab !== 0 ? -1 : 0,
            id: "account",
            class: _normalizeClass({ 'is-active': _ctx.currentTab === 0 }),
            type: "button"
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('staff-form.step1')), 1)
          ], 10, _hoisted_8),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onNavClick(1))),
            role: "tab",
            "aria-selected": _ctx.currentTab === 1,
            disabled: _ctx.progression < 1,
            "aria-controls": "general-tab",
            tabindex: _ctx.currentTab !== 1 ? -1 : 0,
            id: "general",
            class: _normalizeClass({ 'is-active': _ctx.currentTab === 1 }),
            type: "button"
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('staff-form.step2')), 1)
          ], 10, _hoisted_9),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onNavClick(2))),
            role: "tab",
            "aria-selected": _ctx.currentTab === 2,
            disabled: _ctx.progression < 2,
            "aria-controls": "staff-tab",
            tabindex: _ctx.currentTab !== 1 ? -1 : 0,
            id: "staff",
            class: _normalizeClass({ 'is-active': _ctx.currentTab === 2 }),
            type: "button"
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('staff-form.step3')), 1)
          ], 10, _hoisted_10)
        ], 32)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([{ 'is-hidden': _ctx.currentTab !== 0 }, "register-right-tab"]),
        tabindex: "0",
        role: "tabpanel",
        id: "account-tab",
        "aria-labelledby": "account"
      }, [
        _createVNode(_component_FormAccount, {
          onOnSubmit: _ctx.onAccountSubmit,
          title: _ctx.$t('staff-form.step1-description')
        }, null, 8, ["onOnSubmit", "title"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([{ 'is-hidden': _ctx.currentTab !== 1 }, "register-right-tab"]),
        tabindex: "0",
        role: "tabpanel",
        id: "general-tab",
        "aria-labelledby": "general"
      }, [
        _createVNode(_component_FormGeneral, {
          onOnSubmit: _ctx.onGeneralSubmit,
          onPrevTab: _ctx.prevTab,
          countries: _ctx.countries,
          states: _ctx.states
        }, null, 8, ["onOnSubmit", "onPrevTab", "countries", "states"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([{ 'is-hidden': _ctx.currentTab !== 2 }, "register-right-tab"]),
        tabindex: "0",
        role: "tabpanel",
        id: "staff-tab",
        "aria-labelledby": "staff"
      }, [
        _createVNode(_component_FormStaff, {
          onOnSubmit: _ctx.onStaffSubmit,
          onPrevTab: _ctx.prevTab,
          "is-loading": _ctx.isLoading,
          errors: _ctx.errors
        }, null, 8, ["onOnSubmit", "onPrevTab", "is-loading", "errors"])
      ], 2)
    ]),
    _createVNode(_component_ErrorPopin, { active: _ctx.errorRequest }, null, 8, ["active"]),
    _createVNode(_component_ThanksPanel, {
      active: _ctx.progression === 3,
      title: _ctx.$t('staff-form.registering-title'),
      text: _ctx.$t('staff-form.registering-description'),
      back: true
    }, null, 8, ["active", "title", "text"])
  ]))
}